import React from "react";
import { colors, radius, typography } from "../utils/designTokens";
import { detalleCorto } from "../utils/detalleGasto";

const fmt = (n) => `$ ${Number(n || 0).toLocaleString("es-UY", { maximumFractionDigits: 2 })}`;


/**
 * Tabla compacta de gastos para los diálogos del cierre de mes.
 * @param {{ rows: Array<{id?: string, description?: string, shortDescription?: string, amount?: number}>, totalLabel?: string }} props
 */
export default function CierreGastosTabla({ rows = [], totalLabel = "Total a repartir" }) {
  const total = rows.reduce((s, r) => s + (Number(r.amount) || 0), 0);
  return (
    <div style={styles.wrap}>
      <table style={styles.table}>
        <thead>
          <tr>
            <th style={styles.th}>Gasto</th>
            <th style={{ ...styles.th, textAlign: "right" }}>Monto</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r, i) => (
            <tr key={r.id || i} style={i % 2 ? styles.trAlt : undefined}>
              {/* Detalle corto; la descripción completa (facturas de OSE, UTE…) queda en el tooltip. */}
              <td style={styles.td} title={r.description || ""}>{detalleCorto(r) || r.id}</td>
              <td style={{ ...styles.td, ...styles.amount }}>{fmt(r.amount)}</td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr>
            <td style={{ ...styles.td, ...styles.totalLabel }}>{totalLabel}</td>
            <td style={{ ...styles.td, ...styles.amount, ...styles.totalAmount }}>{fmt(total)}</td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
}

const styles = {
  wrap: { border: `1px solid ${colors.gray200}`, borderRadius: radius.sm, overflow: "hidden" },
  table: { width: "100%", borderCollapse: "collapse", fontSize: typography.sizes.base },
  th: {
    textAlign: "left", padding: "8px 10px", background: colors.gray50, color: colors.gray600,
    fontWeight: 400, fontSize: typography.sizes.sm, borderBottom: `1px solid ${colors.gray200}`,
    position: "sticky", top: 0,
  },
  td: { padding: "7px 10px", borderBottom: `1px solid ${colors.gray100}`, color: colors.gray900, verticalAlign: "top" },
  trAlt: { background: "#fbfcfd" },
  amount: { textAlign: "right", whiteSpace: "nowrap", fontVariantNumeric: "tabular-nums" },
  totalLabel: { color: colors.gray600, borderBottom: "none" },
  totalAmount: { color: colors.primary, borderBottom: "none" },
};
